import { WebStorageError } from "./WebStorageError";

/**
 * localStorageから値を取得する関数。
 * 値が取得できなかった場合は空文字を返す。
 */
export const getLocalStorage = (key: string) => {
	try {
		const value = localStorage.getItem(key);
		return value || '';
	} catch (error) {
		// WebStorageErrorはsetLocalStorageで処理するため、エラーログの出力のみとする
		console.error(error);
		return '';
	}
};

/**
 * localStorageに値を格納する関数。
 */
export const setLocalStorage = (key: string, value: string) => {
	try {
		localStorage.setItem(key, value);
	} catch (error) {
		console.error(error);
		throw new WebStorageError('setLocalStorage error');
	}
};

/**
 * localStorageに格納された値を削除する関数。
 */
export const removeLocalStorage = (key: string) => {
	try {
		localStorage.removeItem(key);
	} catch (error) {
		// WebStorageErrorはsetLocalStorageで処理するため、エラーログの出力のみとする
		console.error(error);
	}
};
